import PayFinished from './PayFinished'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function(Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(PayFinished)

    //2.用new 的方式用组件构造器创建出来组件对象
    const buyFinishedDialog = new Construct({ router, store })

    //3.将组件对象手动挂载到某一个元素上
    buyFinishedDialog.$mount(document.createElement('div'))

    //4.upperTip.$el对应的就是div
    document.body.appendChild(buyFinishedDialog.$el)

    //5.在原型中加入UpperTip
    Vue.prototype.$PayFinished = buyFinishedDialog
}

export default obj
